import { passwordPolicyMessages } from "../../../utils/passwordPolicy";

export const humanizeRoleName = (name = "") =>
  String(name)
    .toLowerCase()
    .replace(/_/g, " ")
    .replace(/\b\w/g, (letter) => letter.toUpperCase());

export const buildAssignableRoleOptions = (roles = []) =>
  roles
    .filter((role) => role?.is_active !== false)
    .map((role) => {
      const isSystem = role.is_system !== false;
      const scopeLabel = isSystem
        ? "Sistema"
        : `Personalizado${role.clinica_nombre ? ` · ${role.clinica_nombre}` : ""}`;

      return {
        value: role.idrol,
        label: `${role.nombre}\n${scopeLabel}`,
        searchLabel: [role.nombre, scopeLabel, role.descripcion, role.clinica_nombre]
          .filter(Boolean)
          .join(" "),
        scope_label: scopeLabel,
        scope_type: role.scope_type,
        nombre: role.nombre,
        descripcion: role.descripcion,
        is_system: role.is_system,
        is_active: role.is_active,
        idclinica: role.idclinica,
        clinica_nombre: role.clinica_nombre,
      };
    });

export const buildAdministrativeUserPayload = ({
  user,
  isCreate,
  selectedRoleOption,
  selectedClinicOptions,
}) => {
  const payload = { ...user };

  if (payload.pwd === null || payload.pwd === "") {
    delete payload.pwd;
  }

  if (isCreate) {
    delete payload.nivel_user_id;
    delete payload.user_level;

    if (selectedRoleOption && selectedRoleOption.scope_type === "COMPANY") {
      payload.company_ids = [
        ...new Set((selectedClinicOptions || []).map((option) => option.idcompany)),
      ].filter((idcompany) => idcompany !== undefined && idcompany !== null);
    }
  }

  return payload;
};

export const CUSTOM_CLINIC_MULTICLINIC_MESSAGE =
  "No se puede asignar un rol personalizado de clínica a un usuario asociado a múltiples clínicas.";

export const buildRoleChangePayload = ({
  selectedRoleOption,
  selectedClinicOptions,
  selectedCompanyOptions,
}) => {
  const payload = { idrol: selectedRoleOption ? selectedRoleOption.value : null };
  if (selectedRoleOption?.scope_type === "CLINIC") {
    payload.clinic_ids = (selectedClinicOptions || []).map((option) => option.value);
  }
  if (selectedRoleOption?.scope_type === "COMPANY") {
    payload.company_ids = (selectedCompanyOptions || []).map((option) => option.value);
  }
  return payload;
};

export const validateRoleChange = ({
  selectedRoleOption,
  selectedClinicOptions,
  selectedCompanyOptions,
}) => {
  if (!selectedRoleOption) return "Seleccione el nuevo rol.";
  if (
    selectedRoleOption.is_system === false &&
    selectedRoleOption.scope_type === "CLINIC" &&
    (selectedClinicOptions || []).length !== 1
  ) {
    return CUSTOM_CLINIC_MULTICLINIC_MESSAGE;
  }
  if (selectedRoleOption.scope_type === "CLINIC" && (!selectedClinicOptions || selectedClinicOptions.length === 0)) {
    return "Seleccione clínicas para el nuevo rol.";
  }
  if (selectedRoleOption.scope_type === "COMPANY" && (!selectedCompanyOptions || selectedCompanyOptions.length === 0)) {
    return "Seleccione compañías para el nuevo rol.";
  }
  return "";
};

export const validateAdministrativeUser = ({ user, isCreate, selectedRoleOption, selectedClinicOptions }) => {
  if (!user.full_name) return "Ingrese nombres.";
  if (!user.user_name) return "Ingrese usuario.";
  if (!user.user_email) return "Ingrese email.";
  if (!user.documento) return "Ingrese documento.";
  if (!user.tipo_documento) return "Seleccione tipo de documento.";
  if (!user.users_clinicas || user.users_clinicas.length === 0) {
    return "Seleccione clínicas.";
  }
  if (isCreate && (user.idrol === null || user.idrol === undefined)) {
    return "Seleccione un rol / plantilla.";
  }
  if (
    isCreate &&
    selectedRoleOption?.is_system === false &&
    selectedRoleOption?.scope_type === "CLINIC" &&
    (selectedClinicOptions || []).length !== 1
  ) {
    return CUSTOM_CLINIC_MULTICLINIC_MESSAGE;
  }
  if ((isCreate || user.pwd) && passwordPolicyMessages(user.pwd || "", {
    email: user.user_email,
    userName: user.user_name,
    fullName: user.full_name,
  }).length > 0) {
    return passwordPolicyMessages(user.pwd || "", {
      email: user.user_email,
      userName: user.user_name,
      fullName: user.full_name,
    }).join(" ");
  }
  return "";
};
